import { z } from 'zod';
import { componentStyleSchema } from '../component-catalog.js';
const commonOptionals = {
    queryConfig: z.record(z.string(), z.unknown()).optional(),
    minimized: z.boolean().optional(),
    displayConfig: z.record(z.string(), z.unknown()).optional(),
    annotations: z.array(z.record(z.string(), z.unknown())).optional(),
    style: componentStyleSchema.optional(),
};
const propsSchema = z
    .object({
    sourceDataset: z.string(),
    mapping: z
        .object({
        values: z.string(),
        labels: z.string().optional(),
    })
        .strict(),
    ...commonOptionals,
})
    .strict();
export const histogramDefinition = {
    type: 'Histogram',
    category: 'data',
    propsSchema,
    isDataBacked: true,
    columnRefManifest: ['values', 'labels'],
    needsMeasuredDims: true,
    defaultMinHeight: 200,
    description: 'Histogram over a dataset. Props: sourceDataset (required), mapping ({ values: string, labels?: string }).',
};
//# sourceMappingURL=Histogram.js.map